export const names = [
  'chatweb',
  'email',
  'facebook',
  'instagram',
  'phone',
  'whatsapp',
  'booking',
  'expedia',
  'telegram',
] as const;
export const themes = ['dark', 'light'] as const;
export const variations = [
  'contrast',
  'default',
  'disabled',
  'grey',
  'inverse',
] as const;
